import { Fragment, useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import getRequests from "api/get";
import postRequests from "api/post";
import { setLoyaltyMerchantTheme } from "features/slices/loyaltySlice";
import LoyaltyLogin from "./components/LoyaltyLogin";
import LoyaltyRegister from "./components/LoyaltyRegister";
import NotFound404 from "./components/NotFound404";
import { Loader } from "components";

export default function MerchantHomePage() {
  const [showLogin, setShowLogin] = useState(true);
  const [showRegister, setShowRegister] = useState(false);
  const [loading, setLoading] = useState(true);
  const [merchantTheme, setMerchantTheme] = useState(null);
  const [merchantDetails, setMerchantDetails] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [customerPhoneNumberFromURL, setCustomerPhoneNumberFromURL] =
    useState(null);
  const [recentOrderId, setRecentOrderId] = useState(null);
  const [userShouldSignUp, setUserShouldSignUp] = useState(false);
  const [userShouldEnterBioData, setUserShouldEnterBioData] = useState(false);
  const [invalidSlug, setInvalidSlug] = useState(false);

  let merchantId;
  let merchantLoyaltyDetails;
  const { slug } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const phone = queryParams.get("phone");
  const order = queryParams.get("order");

  const imgUrlBase = "https://payments.ipaygh.com/app/webroot/img/stores/";
  const dispatch = useDispatch();

  const handleShowLogin = () => {
    setShowLogin(true);
    setShowRegister(false);
  };

  const handleShowRegister = () => {
    setShowLogin(false);
    setShowRegister(true);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      if (slug) {
        const merchantSlugRes = await postRequests.getLoyaltyConfigBySlug({
          mod_by: "ADMIN",
          merchant_id: slug,
          slug,
        });
        const merchantSlugData = merchantSlugRes?.data?.data;
        merchantId = merchantSlugData?.loyalty_merchant;
        if (merchantId) {
          const merchantRes = await getRequests.getMerchantDetails(merchantId);
          if (merchantRes && Number(merchantRes?.status) === 0) {
            setMerchantDetails(merchantRes?.data);
            merchantLoyaltyDetails = merchantSlugData;
          }
        } else {
          // Invalid slug - no merchantId returned
          setInvalidSlug(true);
          setLoading(false);
          return;
        }
      }

      if (phone) {
        setCustomerPhoneNumberFromURL(phone);
        const customerRes = await getRequests.checkUser(
          encodeURIComponent(phone)
        );

        if (customerRes && Number(customerRes?.status) === 91) {
          setUserShouldSignUp(true);
          setShowRegister(true);
        }

        if (customerRes && Number(customerRes?.status) === 0) {
          setCustomerDetails(customerRes?.data);

          if (!customerRes?.data?.customer_has_account) {
            setUserShouldSignUp(true);
            setShowRegister(true);
          }

          if (
            customerRes?.data?.dob === "" ||
            customerRes?.data?.customer_name === ""
          ) {
            setUserShouldEnterBioData(true);
          }
        }
      }

      setRecentOrderId(order || null);
    } catch (err) {
      // Optionally handle error/logging
    } finally {
      setLoading(false);
    }
  };

  const fetchMerchantStoreDetails = async () => {
    setLoading(true);
    try {
      const storedMerchantTheme = sessionStorage.getItem("MERCHANT_THEME");
      if (storedMerchantTheme) {
        const parsedTheme = JSON.parse(storedMerchantTheme);
        if (parsedTheme?.merchant_id === merchantId) {
          setMerchantTheme(parsedTheme);
          return;
        }
      }

      const themeData = {
        theme: merchantLoyaltyDetails?.theme_color,
        merchant_id: merchantId,
        auth_banner: `${imgUrlBase}${merchantLoyaltyDetails?.auth_banner}`,
        dashboard_banner: `${imgUrlBase}${merchantLoyaltyDetails?.dashboard_banner}`,
        social_media: merchantLoyaltyDetails?.social_media,
        slug: slug,
      };

      console.log(themeData);

      if (merchantLoyaltyDetails) {
        setMerchantTheme(themeData);
        dispatch(setLoyaltyMerchantTheme(themeData));
        sessionStorage.setItem("MERCHANT_THEME", JSON.stringify(themeData));
      }
    } catch (err) {
      // Optionally handle errors/logging
    } finally {
      setLoading(false);
    }
  };

  const fetchAll = async () => {
    await fetchData();
    if (merchantId) await fetchMerchantStoreDetails();
  };

  // Fetch merchant & customer details + store theme
  useEffect(() => {
    fetchAll();
  }, [merchantId, phone, order, dispatch]);

  if (loading) return <Loader />;

  if (invalidSlug) return <NotFound404 />;

  return (
    <Fragment>
      {showRegister || !showLogin ? (
        <LoyaltyRegister
          merchantDetails={merchantDetails}
          customerDetails={customerDetails}
          customerPhoneNumberFromURL={customerPhoneNumberFromURL}
          recentOrderId={recentOrderId}
          userShouldEnterBioData={userShouldEnterBioData}
          handleShowLogin={handleShowLogin}
          handleShowRegister={handleShowRegister}
          merchantTheme={merchantTheme}
        />
      ) : (
        <LoyaltyLogin
          merchantDetails={merchantDetails}
          customerDetails={customerDetails}
          customerPhoneNumberFromURL={customerPhoneNumberFromURL}
          recentOrderId={recentOrderId}
          handleShowLogin={handleShowLogin}
          handleShowRegister={handleShowRegister}
          merchantTheme={merchantTheme}
        />
      )}
    </Fragment>
  );
}
